import { render } from "./ButtonAbout.vue?vue&type=template&id=301f325a&scoped=true"
import script from "./ButtonAbout.vue?vue&type=script&lang=js"
export * from "./ButtonAbout.vue?vue&type=script&lang=js"

import "./ButtonAbout.vue?vue&type=style&index=0&id=301f325a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-301f325a"]])

export default __exports__